export default __webpack_public_path__ + "static/media/tel-icon.fb9ae5d6.png";